import React, { FC, Consumer, ReactNode } from 'react'
import { createContextualCan } from '@casl/react'
import AbilityContext from './Context'
import { AnyAbility, SubjectType } from '@casl/ability'

const ContextualCan = createContextualCan(AbilityContext.Consumer as Consumer<AnyAbility>)

type Props = {
  I: string
  a: SubjectType
  not?: boolean
  extra?: any
  children?: ReactNode
}

export const Can: FC<Props> = (props) => {
  const a = props.extra ? [props.a, props.extra] : props.a
  return (
    <ContextualCan I={props.I} a={a} not={props.not}>
      {props.children}
    </ContextualCan>
  )
}
